import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'rl-toggle-button',
  templateUrl: './toggle-button.component.html',
  styleUrls: ['./toggle-button.component.scss'],
  changeDetection : ChangeDetectionStrategy.OnPush
})
export class ToggleButtonComponent {

  @Input() active : boolean;
  @Output() onChange : EventEmitter<boolean> = new EventEmitter<boolean>();

  @Input() showState? : boolean = true;
  @Input() stateLabels? = {
    on : 'general.enabled',
    off : 'general.disabled'
  };

  uniqueId : number = Math.random();

  constructor(private ref: ChangeDetectorRef) {}

  toggle(c){
    this.onChange.emit(c);
    this.ref.detectChanges();
  }
}
